<template>
  <v-row no-gutters style="cursor: pointer" @click="$emit('select')">
    <v-col :cols="confronta ? 4 : 6" class="text-truncate d-flex align-center">
      <v-avatar class="mr-4" size="35">
        <v-img :src="avatar_img" />
      </v-avatar>
      {{ nome[0] }}
    </v-col>
    <v-col cols="1" class="green--text text--accent-3 d-flex justify-center">
      {{ element.qta_verde }}
    </v-col>
    <v-col cols="1" class="blue--text d-flex justify-center">
      {{ element.qta_blu }}
    </v-col>
    <v-col cols="2" class="d-flex justify-center">
      {{ element.qta_verde + element.qta_blu }}
    </v-col>
    <template v-if="!confronta">
      <v-col cols="1" />
      <v-col cols="1" class="d-flex justify-center">
        {{ element.n_doc }}
      </v-col>
    </template>
    <template v-else>
      <v-col cols="2" class="d-flex justify-center">
        {{ vendita_confronto || '—' }}
      </v-col>
      <v-col cols="2" class="d-flex justify-center" v-if="variazione !== null" :class="Math.sign(variazione) > 0 ? 'green--text' : 'red--text'">
        {{ variazione.toFixed(0) }} %
      </v-col>
      <v-col v-else cols="2" class="d-flex justify-center">-</v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  props: {
    element: Object,
    confronta: Boolean,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    prodotto() {
      return this.$store.getters.get_prodotto_by_id(this.element.id);
    },
    nome() {
      return this.prodotto.nome.split(" in ");
    },
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/avatar_img/" +
        this.prodotto.id +
        "?t=" +
        this.prodotto.avatar_md5
      );
    },
    variazione() {
      if (!this.vendita_confronto) return null;
      return (
        ((this.element.qta_verde + this.element.qta_blu) * 100 /
          this.vendita_confronto) - 100
      );
    },
    vendita_confronto() {
      const lista = this.$store.getters.get_prodotti_venduti_confronto;
      const entries = lista.filter((p) => String(p.id_prodotto) === String(this.element.id));
      if (!entries.length) return 0;
      return entries.reduce((tot, e) => tot + (e.qta || 0), 0);
    },
  },
};
</script>